export default "__VITE_ASSET__DJ1jxuxq__"